import React, { Suspense } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router'
import type { RouteObject } from 'react-router'
import { Loading } from 'flipper-ui'
import clinicalQuestionnairesRoutes from '@app/components/clinical-questionnaires/routes'
import consultationsRoutes from '@app/components/consultations/routes'
import homeRoutes from '@app/components/home/routes'
import ppeRoutes from '@app/components/ppe/routes'
import risksRoutes from '@app/components/risks/routes'
import safetyQuestionnairesRoutes from '@app/components/safety-questionnaires/routes'
import RouteError from '@core/components/route-error/RouteError'
import AppLayout from '@core/layout/AppLayout'
import publicRoutes from '@core/routes'
import myAccountRoutes from '@core/routes/my-account/routes'

const withErrorElement = (entries: RouteObject[]): RouteObject[] =>
    entries.map(route =>
        route.children
            ? {
                  ...route,
                  errorElement: <RouteError />,
                  children: withErrorElement(route.children)
              }
            : { ...route, errorElement: <RouteError /> }
    )

const routes: RouteObject[] = [
    ...publicRoutes,
    {
        element: <AppLayout />,
        children: [
            ...homeRoutes,
            ...clinicalQuestionnairesRoutes,
            ...consultationsRoutes,
            ...ppeRoutes,
            ...risksRoutes,
            ...safetyQuestionnairesRoutes,
            ...myAccountRoutes
        ]
    }
]

const router = createBrowserRouter(withErrorElement(routes))

export const RouterContainer = () => {
    return (
        <Suspense fallback={<Loading />}>
            <RouterProvider router={router} />
        </Suspense>
    )
}
